const SectionContainer = ({ id, className = '', children }) => {
  return (
    <section id={id} className={` ${className}`}>
      {children}
    </section>
  )
}

export default SectionContainer
